module.exports = __webpack_public_path__ + "img/undraw-remote_team.9551d501.png";